<div class="row" style="padding: 0">
    <div *ngIf="!isLoading && !noData">
        <app-highcharts-generic
            [chartheight]="height"
            [options]="top_five_options"
            [series]="top_five_series"
        ></app-highcharts-generic>
    </div>
    <div *ngIf="!isLoading && noData" class="noDataZiti">No Data</div>
    <app-loader [isLoading]="isLoading"></app-loader>
</div>
